const listaDeContextos = ['crm','dimob','locacao','venda','vistoria'];

export default listaDeContextos;